module.exports = __webpack_public_path__ + "static/cosybmonkeymain-dd44858aacfda3467f18a6af40b5ffe5.jpeg";